import { render } from "./realTimeTrainingView.vue?vue&type=template&id=f6c80ce4&scoped=true&ts=true"
import script from "./realTimeTrainingView.vue?vue&type=script&lang=ts"
export * from "./realTimeTrainingView.vue?vue&type=script&lang=ts"

import "./realTimeTrainingView.vue?vue&type=style&index=0&id=f6c80ce4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c80ce4"]])

export default __exports__